<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
  total: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="checkout__summary">
    <ul class="checkout__summary-recap">
      <li v-for="item in items" :key="item.label">
        <div class="checkout__summary-label">{{ item.label }}</div>
        <div class="checkout__summary-value">{{ item.value }}</div>
      </li>
    </ul>

    <hr class="divider" />

    <div class="checkout__summary-total">
      <div class="checkout__summary-label">
        <div class="product-price product-price--small">
          <span class="product-price__value">{{ $t('EngravingTool.total.label') }}</span>
          <span class="product-price__vat">{{ $t('EngravingTool.total.sublabel') }}</span>
        </div>
      </div>
      <div class="checkout__summary-value">
        <div class="product-price product-price--small">
          <span class="product-price__value">{{ total }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
